<template>
  <div class="inventory">
    <strong class="d-none d-sm-block mr-2">Lagerstatus: </strong>
    <template v-for="item in stock">
      <span
        :class="[
          'inventory__dot',
          item.inStock ? 'inventory__dot--green' : 'inventory__dot--red'
        ]"
      ></span>
      <span
        >{{ item.location }}: {{ item.inStock ? "På lager" : "Udsolgt" }}</span
      >
    </template>
  </div>
</template>

<script>
export default {
  name: "InventoryStatus",
  props: {
    stock: {
      type: Array,
      required: true
    }
  }
};
</script>
